
const incomes = [
    {
        id: 1,
        type: 'income',
        name: "Salary",
        category: "Investments",
        created: "2022-06-16",
        amount: (5000).toFixed(2),
        currency: "$",
        // cover: Investments,
        bankAccount: "Card"
    },
    
]

export default incomes;